// Generated by CoffeeScript 2.7.0
var Count;

import FieldMixins from 'trunks/vue/admin/components/fields/mixins/field_mixin.js';

import BaseField from './field.js';

import SerialNumberFieldMixin from './mixin.js';

export default Count = Vue.extend({
  mixins: [FieldMixins, SerialNumberFieldMixin],
  components: {
    FieldView: BaseField
  },
  template: `<FieldView
  ref="fieldView"
  :editing='editing'
  :field="field"
>
  <template slot="typeOptionBar">自动计数</template>
  <template slot='description'>
    <span>沿用已有的计数器</span>
  </template>
  <div slot="title">自动计数</div>
  <template slot='content'>
    <div>沿用已有的计数器</div>
  </template>
</FieldView>`
});
